import { useApiClient } from '../lib/api-client.js';
import { useQuery } from '@tanstack/react-query';

/**
 * Fetch the TTS voice options exposed by the current app's backend.
 *
 * The list is static enough that we cache it for the lifetime of the session
 * (`staleTime: Infinity`), so opening the voiceover dialog multiple times
 * only hits the network once.
 *
 * @returns `voices` (empty array while loading / on error), `provider` string,
 * plus `isLoading` and `error` from TanStack Query.
 */
function useVoiceOptions() {
    const apiClient = useApiClient();
    const { data, isLoading, error } = useQuery({
        queryKey: ['tts', 'voices'],
        queryFn: () => apiClient.get('/tts/voices'),
        staleTime: Infinity,
    });
    return {
        voices: data?.data.voices ?? [],
        provider: data?.data.provider,
        isLoading,
        error,
    };
}

export { useVoiceOptions };
//# sourceMappingURL=useVoiceOptions.js.map
